import { render, staticRenderFns } from "./StarLabel.vue?vue&type=template&id=48aef6e6&scoped=true&"
import script from "./StarLabel.vue?vue&type=script&lang=js&"
export * from "./StarLabel.vue?vue&type=script&lang=js&"
import style0 from "./StarLabel.vue?vue&type=style&index=0&id=48aef6e6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48aef6e6",
  null
  
)

export default component.exports